import React, {Component} from 'react';
import auth from "../../components/user/services/Auth";
import {connect} from 'react-redux';
import {getLanguage} from '../../store/rootReducer';

class Login extends Component {

  componentDidMount() {
    auth.login(this.props.language);
  };

  render() {
    return (
        <div/>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(Login);